import React from 'react';
import { PackageIcon, GlobeIcon, HeadphonesIcon, LockIcon } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-[100px] px-8 bg-brand-darkGray" data-id="element-7">
      <div className="max-w-[1200px] mx-auto" data-id="element-8">
        <p className="text-[0.75rem] tracking-[4px] uppercase text-brand-red mb-3 font-semibold" data-id="element-9">
          Who We Are
        </p>
        <h2 className="text-[1.8rem] sm:text-[2.4rem] font-extrabold text-brand-text mb-4 leading-[1.2]" data-id="element-10">
          Welcome to <span className="text-brand-red" data-id="element-11">Dogosell</span>
        </h2>
        <div className="w-[50px] h-[3px] bg-brand-red mb-12" data-id="element-12"></div>

        <p className="text-[1.05rem] text-brand-muted max-w-[750px] mb-14 leading-[1.9]" data-id="element-13">
          At Dogosell, we take pride in being your trusted online platform for
          purchasing a diverse range of products. Our mission is to deliver an
          exceptional shopping experience, connecting local businesses with
          consumers both nationwide and worldwide.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-14" data-id="element-14">
          <div className="bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red p-8 transition-transform duration-300 hover:-translate-y-1" data-id="element-15">
            <h3 className="text-[1.1rem] font-bold text-brand-text mb-3 tracking-[1px] uppercase" data-id="element-16">
              Who We Are
            </h3>
            <p className="text-[0.9rem] text-brand-muted leading-[1.8]" data-id="element-17">
              Dogosell is an innovative e-commerce company dedicated to
              providing a vast selection of products through our online store.
              From home essentials to cutting-edge gadgets, we cater to all
              needs and preferences. With a strong emphasis on quality and
              customer service, we strive to exceed expectations with every
              transaction.
            </p>
          </div>
          <div className="bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red p-8 transition-transform duration-300 hover:-translate-y-1" data-id="element-18">
            <h3 className="text-[1.1rem] font-bold text-brand-text mb-3 tracking-[1px] uppercase" data-id="element-19">
              Our Vision
            </h3>
            <p className="text-[0.9rem] text-brand-muted leading-[1.8]" data-id="element-20">
              We aspire to be the global leader in e-commerce, making quality
              products easily accessible to customers across the globe. We
              believe in the power of technology to facilitate commerce, and in
              the importance of connecting sellers with buyers seamlessly.
            </p>
          </div>
        </div>

        <div className="text-[1.3rem] font-bold text-brand-text mb-6 uppercase tracking-[2px]" data-id="element-21">
          Our Services
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-22">
          <div className="flex items-start gap-4 bg-brand-cardBg border border-brand-border p-6 transition-colors duration-300 hover:border-brand-red" data-id="element-23">
            <div className="w-[36px] h-[36px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-24">
              <PackageIcon size={18} data-id="element-25" />
            </div>
            <div data-id="element-26">
              <h4 className="text-[0.9rem] font-bold text-brand-text mb-1.5 uppercase tracking-[0.5px]" data-id="element-27">
                Extensive Product Range
              </h4>
              <p className="text-[0.82rem] text-brand-muted leading-[1.6]" data-id="element-28">
                We offer a diverse selection of product categories that are
                regularly updated to meet customer needs.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-brand-cardBg border border-brand-border p-6 transition-colors duration-300 hover:border-brand-red" data-id="element-29">
            <div className="w-[36px] h-[36px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-30">
              <GlobeIcon size={18} data-id="element-31" />
            </div>
            <div data-id="element-32">
              <h4 className="text-[0.9rem] font-bold text-brand-text mb-1.5 uppercase tracking-[0.5px]" data-id="element-33">
                International Shipping
              </h4>
              <p className="text-[0.82rem] text-brand-muted leading-[1.6]" data-id="element-34">
                We provide shipping options to all merchants and consumers, no
                matter their location.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-brand-cardBg border border-brand-border p-6 transition-colors duration-300 hover:border-brand-red" data-id="element-35">
            <div className="w-[36px] h-[36px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-36">
              <HeadphonesIcon size={18} data-id="element-37" />
            </div>
            <div data-id="element-38">
              <h4 className="text-[0.9rem] font-bold text-brand-text mb-1.5 uppercase tracking-[0.5px]" data-id="element-39">
                Exceptional Customer Support
              </h4>
              <p className="text-[0.82rem] text-brand-muted leading-[1.6]" data-id="element-40">
                Our dedicated team is always available to assist you with any
                inquiries, ensuring a smooth shopping journey.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-brand-cardBg border border-brand-border p-6 transition-colors duration-300 hover:border-brand-red" data-id="element-41">
            <div className="w-[36px] h-[36px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-42">
              <LockIcon size={18} data-id="element-43" />
            </div>
            <div data-id="element-44">
              <h4 className="text-[0.9rem] font-bold text-brand-text mb-1.5 uppercase tracking-[0.5px]" data-id="element-45">
                Secure & Reliable Platform
              </h4>
              <p className="text-[0.82rem] text-brand-muted leading-[1.6]" data-id="element-46">
                We value our customers' security — our platform is designed to
                protect your data and ensure safe transactions.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-brand-cardBg border border-brand-border border-t-[3px] border-t-brand-red p-8 sm:px-10 text-center" data-id="element-47">
          <p className="text-[1rem] text-brand-muted leading-[1.9] mb-3" data-id="element-48">
            At Dogosell, your satisfaction is our top priority. We are committed
            to offering quality products, an effortless shopping experience, and
            customer service that is always here to help you.
          </p>
          <strong className="text-brand-text text-[1.1rem] tracking-[1px] font-bold" data-id="element-49">
            Thank You for Choosing Dogosell
          </strong>
        </div>
      </div>
    </section>;
}